<template>
  <div>
    <v-row :color="corPrimaria" class="diagnostico-header">
      <v-col>
        <v-row>
          <v-col md="10" sm="10" lg="10">
            <h2 v-if="perguntaObj.percentual && percentual < 100">
              {{ perguntaObj.percentual.municipio.nome }}
            </h2>
            <p v-if="perguntaObj.pergunta">
              {{ perguntaObj.pergunta.pergunta.tema.nome }}
            </p>

            <h2 v-if="perguntaObj.pergunta">
              {{ perguntaObj.pergunta.pergunta.numero }} -
              {{ perguntaObj.pergunta.pergunta.texto }}
              <app-modal-show-evidence
                :dialog="showDialog"
                :evidence="perguntaObj.pergunta.pergunta.evidencia"
                :color="'white'"
                v-if="perguntaObj.pergunta.pergunta.evidencia != null"
              >
              </app-modal-show-evidence>

              <p v-if="perguntaObj.pergunta.pergunta.pontos_especificos">
                <v-text-field
                  label="Pontos"
                  name="pontos"
                  type="text"
                  v-model="perguntaObj.pergunta.pontos_especificos"
                ></v-text-field>
              </p>
            </h2>
            <div
              v-if="
                perguntaObj.pergunta &&
                perguntaObj.pergunta.pergunta.possuiComentario
              "
            >
              <v-textarea
                label="Comentário"
                name="Comentário"
                type="text"
                :maxlength="1000"
                solo
                hide-details
                no-resize
                v-model="perguntaObj.pergunta.comentario"
              >
              </v-textarea>
              <div style="text-align: end">
                {{
                  perguntaObj.pergunta.comentario
                    ? perguntaObj.pergunta.comentario.length
                    : 0
                }}/1000 caracteres
              </div>
            </div>
          </v-col>

          <v-col md="2" sm="2" lg="2" class="text-right" align="center">
            <div v-if="percentual <= 100 && perguntaObj.pergunta">
              <p>
                <v-avatar :color="isAnswerTrue">
                  <v-icon color="white" @click="answerQuestion(true)">
                    mdi-thumb-up-outline
                  </v-icon>
                </v-avatar>
              </p>

              <p>
                <v-avatar
                  class="answer-no"
                  :color="isAnswerFalse"
                  v-if="!perguntaObj.pergunta.pergunta.pontos_especificos"
                >
                  <v-icon color="white" @click="answerQuestion(false)">
                    mdi-thumb-down-outline
                  </v-icon>
                </v-avatar>
              </p>
            </div>

            <div v-if="percentual === 100 && !this.perguntaObj.pergunta">
              <v-btn color="warning" class="ml-3" @click="finishTheme()">
                FINALIZAR
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="!isSala" justify="center">
      <v-col justify="center" align="center" class="image-container">
        <v-img
          :src="require('@/assets/img/mapa/cidade-base.jpg')"
          class="image-base"
          v-bind:class="{
            'image-base': percentual < 100,
            'image-base-complete': percentual === 100,
          }"
        >
        </v-img>
        <span>
          <v-img
            :src="require('@/assets/img/mapa/AGR/AGR.png')"
            class="image-content"
          >
          </v-img>
        </span>
        <mapa-lideranca
          v-if="perguntaObj.percentual.tema.nome === 'Liderança'"
          :perguntaObj="perguntaObj"
        ></mapa-lideranca>

        <mapa-compras-publicas
          v-if="perguntaObj.percentual.tema.nome === 'Compras Públicas'"
          :perguntaObj="perguntaObj"
        ></mapa-compras-publicas>

        <mapa-desburocratizacao
          v-if="perguntaObj.percentual.tema.nome === 'Desburocratização'"
          :perguntaObj="perguntaObj"
        ></mapa-desburocratizacao>

        <mapa-desenvolvimento-economico
          v-if="
            perguntaObj.percentual.tema.nome === 'Desenvolvimento Econômico'
          "
          :perguntaObj="perguntaObj"
        ></mapa-desenvolvimento-economico>

        <mapa-educacao-empreendedora
          v-if="perguntaObj.percentual.tema.nome === 'Educação Empreendedora'"
          :perguntaObj="perguntaObj"
        ></mapa-educacao-empreendedora>

        <mapa-gestao-municipal
          v-if="perguntaObj.percentual.tema.nome === 'Gestão Municipal'"
          :perguntaObj="perguntaObj"
        ></mapa-gestao-municipal>

        <mapa-inovacao-e-sustentabilidade
          v-if="
            perguntaObj.percentual.tema.nome === 'Inovação e Sustentabilidade'
          "
          :perguntaObj="perguntaObj"
        ></mapa-inovacao-e-sustentabilidade>

        <mapa-sala-do-empreendedor
          v-if="perguntaObj.percentual.tema.nome === 'Sala Do Empreendedor'"
          :perguntaObj="perguntaObj"
        ></mapa-sala-do-empreendedor>
        <!--
        <mapa-novo
          :perguntaObj="perguntaObj"
        ></mapa-novo>
        -->
      </v-col>
    </v-row>
    <v-footer app color="primary" class="app-footer">
      <v-row style="margin-left: 70px">
        <v-col
          v-show="
            (perguntaObj.pergunta &&
              perguntaObj.pergunta.pergunta.perguntaAnteriorSim > 0) ||
            perguntaObj.percentual.ultimaPerguntaRespondida > 0
          "
          md="1"
          sm="1"
          lg="1"
          justify="center"
          align="center"
          class="return-question"
          @click="returnQuestion()"
        >
          <v-icon justify="center" align="center" color="white" :x-large="true">
            mdi-arrow-left-bold-outline
          </v-icon>
        </v-col>
        <v-col>
          <v-progress-linear :value="percentual" color="white" height="25">
            <strong>{{ percentual }} %</strong>
          </v-progress-linear>
        </v-col>

        <v-col md="2" sm="2" lg="2" class="text-right">
          <v-btn color="warning" class="ml-3" @click="openThemePage()">
            SALVAR E SAIR
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { diagnosticAPI } from "./DiagnosticAPI";
import { attendanceQuestionAPI } from "./AttendanceQuestionAPI";
import { mapActions, mapGetters } from "vuex";
import MapaLideranca from "./MapaLideranca";
import MapaComprasPublicas from "./MapaComprasPublicas";
import MapaDesburocratizacao from "./MapaDesburocratizacao";
import MapaDesenvolvimentoEconomico from "./MapaDesenvolvimentoEconomico";
import MapaEducacaoEmpreendedora from "./MapaEducacaoEmpreendedora";
import MapaGestaoMunicipal from "./MapaGestaoMunicipal";
import MapaInovacaoESustentabilidade from "./MapaInovacaoESustentabilidade";
import MapaSalaDoEmpreendedor from "./MapaSalaDoEmpreendedor";
// import MapaNovo from './MapaNovo'
import AppModalShowEvidence from "./ModalShowEvidence";

export default {
  components: {
    MapaLideranca,
    MapaComprasPublicas,
    MapaDesburocratizacao,
    MapaDesenvolvimentoEconomico,
    MapaEducacaoEmpreendedora,
    MapaGestaoMunicipal,
    MapaInovacaoESustentabilidade,
    MapaSalaDoEmpreendedor,
    // MapaNovo,
    AppModalShowEvidence,
  },
  data() {
    return {
      showDialog: false,
      temaId: this.$route.params.idtema,
      acompanhamentoId: this.$route.params.id,
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      perguntaObj: {
        pergunta: {
          pergunta: {
            tema: {},
          },
        },
        percentual: {
          municipio: {},
          tema: {},
        },
      },
      percentual: 0,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadQuestion() {
      this.setLoading(true);
      diagnosticAPI
        .getQuestion(this.temaId, this.acompanhamentoId)
        .then((resp) => {
          this.perguntaObj = resp.data;
          this.percentual = Math.ceil(
            (this.perguntaObj.percentual.perguntasRespondidas /
              this.perguntaObj.percentual.perguntasTema) *
              100
          );
          if (!this.perguntaObj.pergunta) this.percentual = 100;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    answerQuestion(resposta) {
      this.setLoading(true);
      this.perguntaObj.pergunta.resposta = resposta;
      attendanceQuestionAPI
        .update(this.perguntaObj.pergunta)
        .then((resp) => {
          this.loadQuestion();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    openThemePage() {
      this.$router.push("/diagnostico/" + this.acompanhamentoId + "/tema");
    },
    returnQuestion() {
      this.setLoading(true);
      if (this.perguntaObj.pergunta) {
        this.perguntaObj.percentual.perguntaAtual =
          this.perguntaObj.pergunta.perguntaId;
      } else {
        this.perguntaObj.percentual.perguntaAtual =
          this.perguntaObj.percentual.ultimaPerguntaRespondida;
      }

      diagnosticAPI
        .returnQuestion(this.perguntaObj.percentual)
        .then((resp) => {
          this.perguntaObj = resp.data;
          this.percentual = Math.ceil(
            (this.perguntaObj.percentual.perguntasRespondidas /
              this.perguntaObj.percentual.perguntasTema) *
              100
          );
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    finishTheme() {
      this.setLoading(true);

      diagnosticAPI
        .finishTheme(this.perguntaObj.percentual.acompanhamentoPercentualTemaId)
        .then((resp) => {
          this.$router.push("/diagnostico/" + this.acompanhamentoId + "/tema");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao finalizar pergunta");
        });
    },
  },
  computed: {
    ...mapGetters(["loading", "isSala", "corPrimaria", "isFullAdmin"]),
    isAnswerTrue() {
      if (
        this.perguntaObj.pergunta.jaFoiRespondidaUmaVez &&
        this.perguntaObj.pergunta.ultimaResposta
      ) {
        return "warning";
      }
      return "accent";
    },
    isAnswerFalse() {
      if (
        this.perguntaObj.pergunta.jaFoiRespondidaUmaVez &&
        !this.perguntaObj.pergunta.ultimaResposta
      ) {
        return "error";
      }
      return "accent";
    },
  },
  created() {
    this.loadQuestion();
  },
  mounted() {
    document.getElementsByClassName("v-content__wrap")[0].style.background =
      'url("/assets/img/bg-diagnostico.jpg") no-repeat ';
    document.getElementsByClassName("v-content__wrap")[0].style.backgroundSize =
      "cover";
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
